module.exports = __webpack_public_path__ + "static/media/robotsim.bbb96e86.jpg";